
// You can write more code here

/* START OF COMPILED CODE */

import BaseButton from "../core/BaseButton";
import UIButton from "../core/components/UIButton";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class BtnPlayLevel extends BaseButton {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 60, y ?? 60);

    this.scaleX = 0.7;
    this.scaleY = 0.7;

    // btn_play_screen_png
    const btn_play_screen_png = scene.add.image(0, 0, "level-select", "btn-play-screen.png");
    this.add(btn_play_screen_png);

    // this (components)
    const thisUIButton = new UIButton(this);
    thisUIButton.shouldPulse = true;
    thisUIButton.pulseDelay = 0;
    thisUIButton.pulseScaleEnd = 0.8;
    thisUIButton.pulseSpeed = 1000;
    thisUIButton.pulseRepeat = true;

    /* START-USER-CTR-CODE */
    this.setIdlePulse();
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */
  private idleTween!: Phaser.Tweens.Tween;

  public pausePulse() {
    this.UIButton.pausePulse();
  }

  public resumePulse() {
    this.UIButton.resumePulse();
  }

  private setIdlePulse()
  {
    this.idleTween = this.scene.add.tween({
      targets: [this],
      scale: {from: 1, to: 1.05 },
      duration: 300,
      ease: Phaser.Math.Easing.Quadratic.InOut,
      loop: 2,
      yoyo: true,
      paused: true,
    });

    this.UIButton.setCustomPulseTween(this.idleTween);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
